import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const MeetingLocationMap = ({ lat, lng }) => {
  const position = {
    lat,
    lng
  };

  return (
    <div className="h-[300px] rounded overflow-hidden border">
      <MapContainer center={position} zoom={13} className="h-full">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <LocationMarker position={position} />
      </MapContainer>
    </div>
  );
};

const LocationMarker = ({ position }) => {
  return position.lat && position.lng ? <Marker position={position} /> : null;
};

export default MeetingLocationMap;
